import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "form__title" }, "What will we find?", -1)
const _hoisted_3 = { class: "form__search" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "form__btn",
  type: "submit"
}, "Add", -1)
const _hoisted_5 = {
  key: 0,
  class: "form__message"
}
const _hoisted_6 = { class: "listCity" }
const _hoisted_7 = { class: "listCity__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemCity = _resolveComponent("ItemCity")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "home__form form",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addDateCity && _ctx.addDateCity(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "form__input",
          type: "text",
          minlength: "2",
          placeholder: "City",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cityInput) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.cityInput]
        ]),
        _hoisted_4
      ]),
      (_ctx.showMessageError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.messageError), 1))
        : _createCommentVNode("", true)
    ], 32),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("ul", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createBlock(_component_ItemCity, {
            timeout: 2000,
            key: index,
            itemOb: item
          }, null, 8, ["itemOb"]))
        }), 128))
      ])
    ])
  ]))
}